export default "__VITE_ASSET__BgHSp9Sa__"